// @flow

import * as React from "react"
import {connect} from "react-redux"
import Icon from "./icon"
import {fetchBabiesPaged, toggleBabiesSortBy} from "../actions/babies"
import {BabiesSortByProperties} from "../types"
import {withTranslation} from "react-i18next"
// import ClassNames from 'classnames'
import type {
  BabiesSortBy,
  BabiesSortByProperty,
  BabiesSortByOrder,
  Dispatch,
  State as ReduxState,
} from "../types"

type Props = {
  dispatch: Dispatch,
  sortBy: BabiesSortBy,
  t: any,
}

class BabiesSorters extends React.Component<Props> {
  handleToggleSortBy: (BabiesSortByProperty) => void

  constructor(props) {
    super(props)
    this.handleToggleSortBy = this.handleToggleSortBy.bind(this)
  }

  handleToggleSortBy(sortByProp: BabiesSortByProperty) {
    this.props.dispatch(toggleBabiesSortBy(sortByProp))
    this.props.dispatch(fetchBabiesPaged())
  }

  renderSortIcon(sortByOrder: BabiesSortByOrder) {
    switch (sortByOrder) {
      case "asc":
        return <Icon className="sorter-icon" name="icon-sort-asc" />

      case "desc":
        return <Icon className="sorter-icon" name="icon-sort-desc" />

      default:
        return <Icon className="sorter-icon" name="icon-sort" />
    }
  }

  renderSorter(sortByProp: BabiesSortByProperty) {
    const {t, sortBy} = this.props
    // if we have a active sortBy, apply that order, otherwise take default
    const order = sortBy.property == sortByProp ? sortBy.order : "asc"
    return (
      <div
        key={sortByProp}
        role="button"
        className={`sorter is-${sortByProp}`}
        onClick={() => this.handleToggleSortBy(sortByProp)}
      >
        {t(`dashboard.babies.sortBy.property.${sortByProp}`)}
        {this.renderSortIcon(order)}
      </div>
    )
  }

  render() {
    const {t} = this.props
    return (
      <div className="babies-sorters sorters">
        <span className="text-gray mr-2">
          {t("dashboard.babies.sortBy.label")}
        </span>
        {BabiesSortByProperties.map((p) => this.renderSorter(p))}
      </div>
    )
  }
}

const mapStateToProps = (state: ReduxState) => ({
  sortBy: state.babies.sortBy,
})

export default withTranslation()(connect(mapStateToProps)(BabiesSorters))
